// @flow

import { urlOf } from '../util/api';
import PaymentLinkData from './PaymentLinkData';

export class PaymentInfo {
  transactionId: string;
  subtotalWithTax: double;
  subtotalWithoutTax: double;
  tax: double;
  total: double;

  copyFrom(raw: any) {
    this.transactionId = raw.transactionId;
    this.subtotalWithTax = raw.subtotalWithTax;
    this.subtotalWithoutTax = raw.subtotalWithoutTax;
    this.tax = raw.tax;
    this.total = raw.total;
  }
}

class PaymentData {
  vendor: string;
  callbackUrl: string;
  scripts: Array<string>;
  error: string;
  linkData: ?PaymentLinkData;
  info: ?PaymentInfo;

  copyFrom(raw: any) {
    this.vendor = raw.vendor;
    this.callbackUrl = urlOf(raw.callbackUrl);
    this.scripts = raw.scripts || [];
    this.linkData = raw.linkData;
    this.error = raw.error;
    if (!!raw.info) {
      this.info = new PaymentInfo();
      this.info.copyFrom(raw.info);
    }
  }
}

export default PaymentData;
